import { render } from "./NawSwitch.vue?vue&type=template&id=cd0499d4&scoped=true"
import script from "./NawSwitch.vue?vue&type=script&lang=js"
export * from "./NawSwitch.vue?vue&type=script&lang=js"

import "./NawSwitch.vue?vue&type=style&index=0&id=cd0499d4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd0499d4"]])

export default __exports__